import { useTheme } from "../../components/ThemeProvider";
import { getColorStyles } from "../utils/colors";
export const useColorable = (colorsProps) => getColorStyles(colorsProps, useTheme());
export const ColorsProvider = ({ children, ...colorsProps }) => children?.(useColorable(colorsProps));
//# sourceMappingURL=ColorsProvider.js.map